import { getI18n, Trans } from "react-i18next";
import routes from "routes/routes";

import { AppEvents } from "services/events";
import { BEValidationErrorConst, ErrorConst } from "types/BETypes";
import { HELP_EMAIL } from "constants/shared";
import { getErrorMessageFromResponse } from "helpers/shared/errors";

import { CustomLinkSmall } from "uikit";
import { EModalTypes, IModalProps } from "uikit/Modal/types";

export const showErrorModal = (
  error?: any,
  callback?: () => any,
  config?: Partial<IModalProps>,
) => {
  const validationErrorMessage = error?.data?.validationError?.map((it: string) => {
    if (it.includes(BEValidationErrorConst.PHONE_NUMBER_VALIDATION_ERROR)) {
      return ErrorConst.PHONE_NUMBER_VALIDATION_ERROR;
    }
    return "";
  })?.[0];

  const errorMessage = validationErrorMessage || getErrorMessageFromResponse(error);

  AppEvents.emit("SetGlobalModal", {
    type: EModalTypes.ERROR,
    title: <Trans i18nKey={"errors.defaultTitle"}> </Trans>,
    isOpen: true,
    mainButton: {
      text: <Trans i18nKey={"common.modal.okay"}> </Trans>,
      onClick: () => {
        callback ? callback() : AppEvents.emit("SetGlobalModal", { isOpen: false });
      },
    },
    onClose: callback || undefined,
    message: (
      <Trans
        i18nKey={`errors.${errorMessage}`}
        values={{ helpEmail: HELP_EMAIL }}
        defaults={getI18n().t("errors.defaultMessage")}
      >
        {" "}
        <CustomLinkSmall href={`mailto: ${HELP_EMAIL}`}>{HELP_EMAIL}</CustomLinkSmall>
        <CustomLinkSmall href={routes.RECOVERY_ACCOUNT}></CustomLinkSmall>
      </Trans>
    ),
    ...config,
  });
};
